var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavouriteActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8396 4.61183C20.3289 4.10083 19.7224 3.69547 19.055 3.41891C18.3875 3.14235 17.6721 3 16.9496 3C16.2271 3 15.5117 3.14235 14.8443 3.41891C14.1768 3.69547 13.5704 4.10083 13.0596 4.61183L11.9996 5.67183L10.9396 4.61183C9.90794 3.58013 8.50866 3.00053 7.04963 3.00053C5.5906 3.00053 4.19132 3.58013 3.15963 4.61183C2.12794 5.64352 1.54834 7.04279 1.54834 8.50183C1.54834 9.96086 2.12794 11.3601 3.15963 12.3918L4.21963 13.4518L11.9996 21.2318L19.7796 13.4518L20.8396 12.3918C21.3506 11.8811 21.756 11.2746 22.0325 10.6072C22.3091 9.93972 22.4515 9.22431 22.4515 8.50183C22.4515 7.77934 22.3091 7.06393 22.0325 6.39647C21.756 5.72901 21.3506 5.12258 20.8396 4.61183Z",
    fill: "#EC187B",
    stroke: "#EC187B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteActiveIcon);
export default __webpack_public_path__ + "static/media/favouriteActiveIcon.e78f06576edc3811a4ce3efb1952532f.svg";
export { ForwardRef as ReactComponent };